/** Phone-sized viewports use tap-to-add; larger screens use drag-from-drawer. */
export function isOnboardingMobileDevice(): boolean {
  if (typeof window === "undefined") return false;
  return window.matchMedia("(max-width:600px)").matches;
}
